export const authorizedEmailDomains = new Set([
    'developpement-durable.gouv.fr',
    'beta.gouv.fr',
    'aisne.gouv.fr',
    'nord.gouv.fr',
    'loiret.gouv.fr'
])